namespace Worthington.Calculators {
    function coilCalculator() {
        let coilCalculator = document.getElementById('coilCalculator');

        // If the coil calculator form is on the page
        if (coilCalculator) {
            let form = document.getElementsByTagName('form')[0];
            let submitButton = form.getElementsByTagName('button')[0];
            let radioButtons = document.getElementsByName('calculationMethod');
            let newsletterForm = document.querySelectorAll('[data-sf-role="form-container"]')[0];

            // Add class to conatiner of form
            newsletterForm.classList.add('calculator-form');

            // Set calculationMethod to the default and add js-checked to the default checked radio button
            let calculationMethod = 'byDiameter';
            radioButtons[0].classList.add('js-checked');

            // Loop through the radio buttons on the page
            for (let i = 0; i < radioButtons.length; i++) {
                // Add an onClick event listener to all radio button
                radioButtons[i].addEventListener('click', function() {
                    let previousChecked = document.getElementsByClassName('js-checked');

                    // Remove all occurances of the class js-checked and add the class js-checked to clicked radio button
                    previousChecked[0].classList.remove('js-checked');
                    radioButtons[i].classList.add('js-checked');

                    // Set calculationMethod equal to 
                    let checkedButton = document.getElementsByClassName('js-checked')[0] as HTMLInputElement;
                    calculationMethod = checkedButton.value
                })
            }

            // On click of form submit button...
            submitButton.addEventListener('click', function(e) {
                // Stop the form from submitting
                e.preventDefault();

                let piwOutput;
                let weightOutput;
                let lengthOutput;
                let idOutput1;
                let odOutput1;
                let sidewallOutput1;
                let idOutput2;
                let odOutput2;
                let sidewallOutput2;
                let idOutput3;
                let odOutput3;
                let sidewallOutput3;

                // Get all calculator result fields
                if (calculationMethod == 'byDiameter') {
                    piwOutput = document.getElementById('coilDiameterPIW');
                    weightOutput = document.getElementById('coilDiameterWeight');
                    lengthOutput = document.getElementById('coilDiameterLength');
                    idOutput1 = document.getElementById('coilDiameterIDResult');
                    odOutput1 = document.getElementById('coilDiameterODResult');
                    sidewallOutput1 = document.getElementById('coilDiameterSidewall');
                } else if (calculationMethod == 'byWeight') {
                    piwOutput = document.getElementById('coilDiameterPIW');
                    weightOutput = document.getElementById('coilDiameterWeight');
                    lengthOutput = document.getElementById('coilDiameterLength');
                    idOutput1 = document.getElementById('coilWeightID-1');
                    odOutput1 = document.getElementById('coilWeightOD-1');
                    sidewallOutput1 = document.getElementById('coilWeightSidewall-1');
                    idOutput2 = document.getElementById('coilWeightID-2');
                    odOutput2 = document.getElementById('coilWeightOD-2');
                    sidewallOutput2 = document.getElementById('coilWeightSidewall-2');
                    idOutput3 = document.getElementById('coilWeightID-3');
                    odOutput3 = document.getElementById('coilWeightOD-3');
                    sidewallOutput3 = document.getElementById('coilWeightSidewall-3');
                }

                // If a calculator result field is filled out...
                if (piwOutput.innerHTML != '&nbsp;' && piwOutput.innerHTML != '') {
                    // Get all hidden form fields
                    let piwHidden = document.getElementById('HiddenField-1') as HTMLInputElement;
                    let weightHidden = document.getElementById('HiddenField-2') as HTMLInputElement;
                    let lengthHidden = document.getElementById('HiddenField-3') as HTMLInputElement;
                    let idHidden1 = document.getElementById('HiddenField-4') as HTMLInputElement;
                    let odHidden1 = document.getElementById('HiddenField-5') as HTMLInputElement;
                    let sidewallHidden1 = document.getElementById('HiddenField-6') as HTMLInputElement;
                    let idHidden2 = document.getElementById('HiddenField-7') as HTMLInputElement;
                    let odHidden2 = document.getElementById('HiddenField-8') as HTMLInputElement;
                    let sidewallHidden2 = document.getElementById('HiddenField-9') as HTMLInputElement;
                    let idHidden3 = document.getElementById('HiddenField-10') as HTMLInputElement;
                    let odHidden3 = document.getElementById('HiddenField-11') as HTMLInputElement;
                    let sidewallHidden3 = document.getElementById('HiddenField-12') as HTMLInputElement;

                    // Set the hidden fields depending on the calculationMethod
                    if (calculationMethod == 'byDiameter') {
                        piwHidden.value = piwOutput.innerHTML;
                        weightHidden.value = weightOutput.innerHTML;
                        lengthHidden.value = lengthOutput.innerHTML;
                        idHidden1.value = idOutput1.innerHTML;
                        odHidden1.value = odOutput1.innerHTML;
                        sidewallHidden1.value = sidewallOutput1.innerHTML;
                        idHidden2.value = '';
                        odHidden2.value = '';
                        sidewallHidden2.value = '';
                        idHidden3.value = '';
                        odHidden3.value = '';
                        sidewallHidden3.value = '';
                    } else if (calculationMethod == 'byWeight') {
                        piwHidden.value = piwOutput.innerHTML;
                        weightHidden.value = weightOutput.innerHTML;
                        lengthHidden.value = lengthOutput.innerHTML;
                        idHidden1.value = idOutput1.innerHTML;
                        odHidden1.value = odOutput1.innerHTML;
                        sidewallHidden1.value = sidewallOutput1.innerHTML;
                        idHidden2.value = idOutput2.innerHTML;
                        odHidden2.value = odOutput2.innerHTML;
                        sidewallHidden2.value = sidewallOutput2.innerHTML;
                        idHidden3.value = idOutput3.innerHTML;
                        odHidden3.value = odOutput3.innerHTML;
                        sidewallHidden3.value = sidewallOutput3.innerHTML;
                    }

                    // Submit the form
                    form.submit();
                // Otherwise...
                } else {
                    let errorMessage = '<div class="alert alert-danger js-calculator-error">You must run the calculator first to be able to send results to your email.</div>';
                    let error = document.getElementsByClassName('js-calculator-error')[0];
                                
                    // Add error message
                    if (!error) {
                        newsletterForm.insertAdjacentHTML('afterbegin', errorMessage);
                    }
                }
            })
        }
    }

    function smartLidCalculator() {
        let smartLidCalculator = document.getElementById('smartLidCalculator');

        // If the smart lid calculator form is on the page
        if (smartLidCalculator) {
            let form = document.getElementsByTagName('form')[0];
            let submitButton = form.getElementsByTagName('button')[0];
            let newsletterForm = document.querySelectorAll('[data-sf-role="form-container"]')[0];

            // Add class to conatiner of form
            newsletterForm.classList.add('calculator-form');

            // On click of the form submit button
            submitButton.addEventListener('click', function(e) {
                // Stop the form from submitting
                e.preventDefault();

                // Get all calculator results fields
                let smartLidOutput = document.getElementById('smartLidOutput');
                let standardLidOutput = document.getElementById('standardLidOutput');
                let costSavingsOutput = document.getElementById('costSavingsOutput');
                let tripSavingsOutput = document.getElementById('tripSavingsOutput');
                let savingsPerCustomerOutput = document.getElementById('savingsPerCustomerOutput');
                let fiveYearsOutput = document.getElementById('fiveYearsOutput');
                let tenYearsOutput = document.getElementById('tenYearsOutput');
                let fifteenYearsOutput = document.getElementById('fifteenYearsOutput');

                // If a calculator result field is filled out...
                if (smartLidOutput && smartLidOutput.innerHTML != '0') {
                    // Get all hidden form fields
                    let smartLidHidden = document.getElementById('HiddenField-1') as HTMLInputElement;
                    let standardLidHidden = document.getElementById('HiddenField-2') as HTMLInputElement;
                    let costSavingsHidden = document.getElementById('HiddenField-3') as HTMLInputElement;
                    let tripSavingsHidden = document.getElementById('HiddenField-4') as HTMLInputElement;
                    let savingsPerCustomerHidden = document.getElementById('HiddenField-5') as HTMLInputElement;
                    let fiveYearsHidden = document.getElementById('HiddenField-6') as HTMLInputElement;
                    let tenYearsHidden = document.getElementById('HiddenField-7') as HTMLInputElement;
                    let fifteenYearsHidden = document.getElementById('HiddenField-8') as HTMLInputElement;

                    // Set the hidden form field values
                    smartLidHidden.value = smartLidOutput.innerHTML;
                    standardLidHidden.value = standardLidOutput.innerHTML;
                    costSavingsHidden.value = costSavingsOutput.innerHTML;
                    tripSavingsHidden.value = tripSavingsOutput.innerHTML;
                    savingsPerCustomerHidden.value = savingsPerCustomerOutput.innerHTML;
                    fiveYearsHidden.value = fiveYearsOutput.innerHTML;
                    tenYearsHidden.value = tenYearsOutput.innerHTML;
                    fifteenYearsHidden.value = fifteenYearsOutput.innerHTML;

                    // Submit the form
                    form.submit();
                } else {
                    let errorMessage = '<div class="alert alert-danger js-calculator-error">You must run the calculator first to be able to send results to your email.</div>';
                    let error = document.getElementsByClassName('js-calculator-error')[0];
            
                    // Add error message
                    if (!error) {
                        newsletterForm.insertAdjacentHTML('afterbegin', errorMessage);
                    }
                }
            })
        }
    }

    export const init = () => {
        coilCalculator();
        smartLidCalculator();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	Worthington.Calculators.init();
});